export default class Asset extends Backbone.Model
  defaults:
    persisted: false

  url: ->
    "/clips/#{@get("clipId")}/assets/#{@get("id")}"

  save: (options) ->
    $.ajax
      url: "/media/s3_upload"
      type: 'POST'
      dataType: 'json'
      data: { data_remote_url: @get("url") }
      success: (data) =>
        @set
          id: data.id
          url: data.url
          small: data.small
          persisted: true
        options.success()
      error: (xhr, status, error) ->
        options.error()

  saveAssetting: (options) ->
    $.ajax
      url: @url() + '/assetting'
      type: 'POST'
      success: (data) ->
        options.success()
      error: (xhr, status, error) ->
        options.error()



// WEBPACK FOOTER //
// ./app/javascript/backbone/projects/models/asset.js.coffee